module.exports = "fonts/Wrangler.woff";